import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import Detail from './Details';
import Section from '../Section';
import { joinPath } from 'utils/path';
function ExecutiveSummary({ className, editPath, executiveSummary, language }) {
  const location = useLocation();
  
  const executiveSummaryData = useMemo(() => {
    return executiveSummary?.[language] ?? [];
  }, [executiveSummary, language]);

  const path = useMemo(() => {
    return editPath ? joinPath(editPath, 'executive-summary') : '';
  }, [editPath]);

  const editPathState = useMemo(() => ({ background: location }), [location]);

  return (
    <Section className={className} editPath={path} editPathState={editPathState} title="title.executiveSummary">
      {!!executiveSummaryData.length && <Detail executiveSummary={executiveSummaryData} />}
    </Section>
  );
}

ExecutiveSummary.propTypes = {
  className: PropTypes.string,
  editPath: PropTypes.string,
  executiveSummary: PropTypes.object.isRequired,
  language: PropTypes.string.isRequired
};

export default ExecutiveSummary;
